import React from 'react';

// ─────────────────────────────────────────────────────────────────────────
// NavGlyph — geteilte Navigations-Icons für Web-Rail UND Mobile-Pill.
//
// Calm-Stil (neu): EIN dünner Linienstrich (~1.7), runde Enden, minimal,
// KEINE dicken Füll-Akzente mehr. Der Aktiv-Zustand kommt von außen (neutrale
// Fläche hinter dem Icon in Rail/BottomNav), nicht über einen roten Pop.
// Regel: neue Nav-Icons hier im selben dünnen Linienstil ergänzen.
//
// Parität: Mobile (BottomNav) und Web (DesktopShell) ziehen aus diesem Modul.
// ─────────────────────────────────────────────────────────────────────────

export const NAV_GLYPHS = {
  dashboard: (
    <>
      <rect x="3.5" y="3.5" width="7" height="7" rx="2" />
      <rect x="13.5" y="3.5" width="7" height="7" rx="2" />
      <rect x="3.5" y="13.5" width="7" height="7" rx="2" />
      <rect x="13.5" y="13.5" width="7" height="7" rx="2" />
    </>
  ),
  // wallet = „Transaktionen" — gegenläufige Pfeile (Austausch)
  wallet: (
    <>
      <path d="M4 8.5h13l-3.2-3.2" />
      <path d="M20 15.5H7l3.2 3.2" />
    </>
  ),
  // markets = „Märkte" — klare Linien-Chart (statt Marktstand)
  markets: <path d="M4 17l5-6 4 4 7-9" />,
  // berichte = „Smart Check" — Schild + Haken
  berichte: (
    <>
      <path d="M12 3.2l6.8 2.4v5.1c0 4.3-2.9 7.5-6.8 8.6-3.9-1.1-6.8-4.3-6.8-8.6V5.6L12 3.2z" />
      <path d="M9.1 11.6l2 2 3.8-3.9" />
    </>
  ),
  // reports = „Berichte" — Dokument mit Eselsohr + Textzeilen
  reports: (
    <>
      <path d="M14 3.6H7.7A1.6 1.6 0 0 0 6.1 5.2V18.8A1.6 1.6 0 0 0 7.7 20.4H16.3A1.6 1.6 0 0 0 17.9 18.8V7.5L14 3.6Z" />
      <path d="M14 3.6V7.5H17.9" />
      <path d="M9.7 12.2h4.6M9.7 15.4h4.6" />
    </>
  ),
  // alerts = Glocke
  alerts: (
    <>
      <path d="M18 9a6 6 0 0 0-12 0c0 6-2.6 7.8-2.6 7.8h17.2S18 15 18 9" />
      <path d="M13.7 20.2a2 2 0 0 1-3.4 0" />
    </>
  ),
  // pricing = „Tarife" — Preis-Tag
  pricing: (
    <>
      <path d="M3.6 12.6l8.2-8.2a1.6 1.6 0 0 1 1.1-.5H19a1.4 1.4 0 0 1 1.4 1.4v6.1a1.6 1.6 0 0 1-.5 1.1l-8.2 8.2a1.4 1.4 0 0 1-2 0l-6.1-6.1a1.4 1.4 0 0 1 0-2z" />
      <circle cx="16" cy="8" r="1.2" />
    </>
  ),
  // settings = „Profil"
  settings: (
    <>
      <circle cx="12" cy="8.2" r="3.3" />
      <path d="M6 20a6 6 0 0 1 12 0" />
    </>
  ),
};

export function NavGlyph({ id, active = false, stroke = 'currentColor', accentColor, size = 24, sw = 1.7 }) {
  const base = NAV_GLYPHS[id];
  if (!base) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      strokeWidth={sw}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ display: 'block', flexShrink: 0 }}
    >
      {base}
    </svg>
  );
}

export default NavGlyph;
